var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _ellipse, _path10, _rect, _ellipse2, _path11, _path12, _ellipse3, _ellipse4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuoteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 141,
    viewBox: "0 0 166 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M163.143 58.4286C167.599 115.399 121.184 141 84.5899 141C47.9956 141 0.428711 110.229 0.428711 77.456C0.428711 44.683 9.16374 24.2749 45.9748 11.6375C82.7858 -0.999985 158.687 1.45824 163.143 58.4286Z",
    fill: "#F7F7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.5 57.6246L83 74.733V42.0715L118.5 57.6246Z",
    fill: "#7B79DF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118.5 99.6178V57.6245L83 74.7329V116.726L118.5 99.6178Z",
    fill: "#B1B0F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4999 99.6178V57.6245L83 74.7329V116.726L47.4999 99.6178Z",
    fill: "#8E8CEE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4999 57.6246L83 74.733V42.0715L47.4999 57.6246Z",
    fill: "#B1B0F5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6252 73.1776L47.5003 57.6245L83.0004 74.7329L74.1254 91.8413L38.6252 73.1776Z",
    fill: "#7B79DF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M127.376 73.1776L118.501 57.6245L83.0011 74.7329L91.8761 91.8413L127.376 73.1776Z",
    fill: "#E6E5FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.855 23.6425C126.223 24.5262 125.806 25.5415 124.922 25.9101C119.448 28.1932 114.549 33.3216 110.702 39.8506C106.871 46.3521 104.196 54.0567 103.069 61.1996C102.919 62.1455 102.032 62.7913 101.086 62.642C100.14 62.4928 99.4943 61.605 99.6435 60.6592C100.836 53.1023 103.654 44.9815 107.714 38.0903C111.758 31.2266 117.149 25.3951 123.587 22.7098C124.471 22.3411 125.486 22.7587 125.855 23.6425Z",
    fill: "#B1B0F5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.8029 12.4162C79.4466 13.1251 79.3936 14.2216 78.6847 14.8653C77.6492 15.8053 77.4499 17.0057 77.9647 18.5842C78.5032 20.2355 79.7753 22.0239 81.2444 23.4914C83.3949 25.6395 84.3496 28.0371 83.8834 30.7958C83.4506 33.3574 81.8226 35.9859 79.5323 38.8176C77.5563 41.2607 77.1569 43.4996 77.5699 45.3931C77.9966 47.3495 79.3522 49.2098 81.3807 50.6823C82.1556 51.2448 82.3277 52.329 81.7652 53.1039C81.2027 53.8788 80.1185 54.051 79.3436 53.4885C76.8276 51.662 74.8368 49.1344 74.1819 46.132C73.5134 43.0668 74.2973 39.7761 76.8362 36.637C79.0608 33.8865 80.1891 31.8471 80.4643 30.2181C80.7063 28.786 80.3209 27.4701 78.7938 25.9447C77.1093 24.2621 75.4378 22.0199 74.668 19.6593C73.8744 17.2259 74.002 14.4331 76.3538 12.2979C77.0628 11.6543 78.1593 11.7072 78.8029 12.4162Z",
    fill: "#8E8CEE"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 132.974,
    cy: 20.6541,
    rx: 3.05962,
    ry: 3.05962,
    fill: "#8E8CEE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M113.14 2.73127C113.162 2.56498 113.367 2.49788 113.483 2.61891L115.949 5.1893C115.996 5.23788 116.064 5.25975 116.13 5.24748L119.633 4.59837C119.798 4.56781 119.925 4.74163 119.846 4.88948L118.163 8.02959C118.131 8.08894 118.132 8.1603 118.164 8.21947L119.864 11.3502C119.944 11.4976 119.818 11.6722 119.652 11.6425L116.146 11.0128C116.08 11.0009 116.012 11.0231 115.966 11.072L113.513 13.656C113.398 13.7777 113.193 13.7117 113.17 13.5455L112.686 10.0162C112.676 9.94954 112.634 9.89192 112.574 9.86294L109.358 8.32919C109.207 8.25698 109.206 8.0417 109.357 7.96864L112.564 6.41712C112.625 6.3878 112.666 6.32995 112.675 6.26319L113.14 2.73127Z",
    fill: "#8E8CEE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 97.2778,
    y: 24.825,
    width: 8.15899,
    height: 8.15899,
    rx: 1,
    transform: "rotate(-22.7167 97.2778 24.825)",
    fill: "#8E8CEE"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.1045,
    cy: 30.8531,
    rx: 3.05962,
    ry: 3.05962,
    fill: "#8E8CEE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.105 33.7487C43.7557 34.6402 44.1952 35.6462 45.0867 35.9955C48.0852 37.1705 51.5814 39.8941 54.8763 43.5583C58.1479 47.1967 61.0973 51.6253 63.0567 56.0339C63.4455 56.9089 64.4701 57.303 65.3452 56.9141C66.2202 56.5252 66.6143 55.5006 66.2254 54.6256C64.1053 49.8554 60.9474 45.1239 57.4548 41.2398C53.9855 37.3816 50.0606 34.2203 46.3519 32.767C45.4603 32.4176 44.4544 32.8571 44.105 33.7487Z",
    fill: "#8E8CEE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7732 9.67661C51.8943 9.56059 52.0959 9.63625 52.1107 9.80333L52.4264 13.3517C52.4324 13.4188 52.4717 13.4783 52.531 13.5102L55.6695 15.1956C55.8173 15.275 55.8076 15.49 55.6533 15.5558L52.3761 16.9525C52.3142 16.9789 52.2697 17.0347 52.2577 17.101L51.6247 20.6067C51.5949 20.7718 51.3873 20.829 51.2771 20.7026L48.936 18.0174C48.8918 17.9667 48.8249 17.9416 48.7582 17.9507L45.2285 18.4319C45.0623 18.4546 44.9437 18.2749 45.0299 18.131L46.8602 15.0747C46.8948 15.017 46.898 14.9457 46.8687 14.8851L45.3203 11.6768C45.2474 11.5257 45.3816 11.3574 45.5451 11.3949L49.0174 12.1912C49.083 12.2062 49.1518 12.1872 49.2004 12.1407L51.7732 9.67661Z",
    fill: "#8E8CEE"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.2253,
    cy: 3.55544,
    rx: 3.05962,
    ry: 3.05962,
    transform: "rotate(-12.6516 84.2253 3.55544)",
    fill: "#8E8CEE"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 65.6646,
    cy: 30.8528,
    rx: 3.05962,
    ry: 3.05962,
    fill: "#8E8CEE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteIcon);
export default __webpack_public_path__ + "static/media/quote-icon.15cb6e9043d87359d9ca414120695a24.svg";
export { ForwardRef as ReactComponent };